import { render, staticRenderFns } from "./nav-main.vue?vue&type=template&id=a90d057c"
import script from "./nav-main.vue?vue&type=script&lang=js"
export * from "./nav-main.vue?vue&type=script&lang=js"
import style0 from "./nav-main.vue?vue&type=style&index=0&id=a90d057c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports